var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PresentPersonelListWeb"},[_c('v-data-table',{attrs:{"dense":"","disable-sort":true,"headers":_vm.headers,"items":_vm.list,"hide-default-footer":!_vm.pagination,"disable-pagination":!_vm.pagination,"footer-props":{
      'items-per-page-options': [5, 10, 15, 50, 100, -1],
      'items-per-page-text': _vm.$t('rowsPerPage'),
      'show-first-last-page': true,
    },"item-class":_vm.getItemBackColor},on:{"click:row":_vm.handleClick},scopedSlots:_vm._u([{key:"item.AbsentType",fn:function(ref){
    var item = ref.item;
return [_c('span',[_vm._v(" "+_vm._s(_vm.getAbsentType(item.AbsentType))+" ")])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }